import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import fields from '@/constants/fields';
import { states } from '@/constants/lifecycle';
import { fetchWorkspaceLocations } from '@/workspaces/actions';
import fetch from '@/hooks/fetch';

const listItems = (locations) => locations.map((item) => ({
  key: `workspace_condition_location_${item.id}`,
  text: item.description,
  value: item.value,
  description: item.regional_display_name,
}));

const WorkspaceLocationsConditionDropdown = ({
  datasetCondition,
  error,
  fetchData,
  locations,
  updateProperties,
  readStatus,
  saveStatus,
}) => {
  const intl = useIntl();
  fetch.useFetchByCategory(fetchData, 'lookups', readStatus);

  return (
    <Dropdown
      id="ADDUC_0007_locations"
      className="aridhia-workflow-location-contition-dropdown"
      disabled={saveStatus === states.PENDING || readStatus === states.PENDING}
      error={!!error}
      fluid
      loading={readStatus === states.PENDING}
      multiple
      noResultsMessage={intl.formatMessage({ id: 'dataset.condition.workspace.locations.none' })}
      onChange={(e, { value }) => { updateProperties({ locations: value }, fields.NAME); }}
      options={listItems(locations)}
      placeholder={intl.formatMessage({ id: 'dataset.condition.workspace.locations.placeholder' })}
      search
      selection
      value={datasetCondition.context.locations}
    />
  );
};

export const mapStateToProps = ({
  workspaces: { locations: { lookups: { results, readStatus } } },
}) => ({ locations: results, readStatus });

export const mapDispatchToProps = {
  fetchData: fetchWorkspaceLocations,
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkspaceLocationsConditionDropdown);
